import { useTheme } from '@emotion/react';
import { Flex } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Title } from '~/domains/design-system/Title';
import IconGiftAurora from '~/domains/design-system/icons/IconGiftAurora';
import type { NormalizedBonus } from '~/domains/promotions/types/bonus.types';

interface RegistrationBonusBannerProps {
  /** The normalized bonus data from the API */
  bonus: NormalizedBonus;
}

export function RegistrationBonusBanner({ bonus }: RegistrationBonusBannerProps) {
  const theme = useTheme();
  const { t } = useTranslation('auth');

  return (
    <Flex align="center" gap={theme.other.spacing._6} justify="center">
      <IconGiftAurora size={20} strokeWidth={3.25} />
      <Title variant="subhead-small" color={theme.colors.gray2[6]}>
        {bonus.description || bonus.subtitle || t('signUp.referralBonus.banner', { bonus: bonus.title })}
      </Title>
    </Flex>
  );
}
